export const MONEDA = 'TP001'
export const LISTAPRECIO = 'TP002'
export const GRUPOCONTABLECOMPRA = 'TP003'
export const GRUPOCONTABLEVENTA = 'TP004'
export const GRUPOCONTABLEINVENTARIO = 'TP005'
export const GRUPOCONTABLEEXISTENCIA = 'TP006'
export const CONDUCTOR = 'TP007'
export const PLACA = 'TP008'
export const AREASINTERNAS = 'TP009'
export const PLANTILLACOMENTARIOVENTA = 'TP010'
export const HUECONUMERODOCUMENTOVENTAS = 'TP011'
export const TECNICO = 'TP013'
export const TALLERSERVICIO = 'TP014'
export const TALLERSUBSERVICIO1 = 'TP015'
export const TALLERSUBSERVICIO2 = 'TP016'
export const ISLAGRIFO = 'TP017'
export const PRECIOXLISTA = 'TP018'
export const MEDIOSPAGO = 'TP019'
export const MEDIOSPAGOVENTAS = 'TP020'
export const SUBMEDIOSPAGO = 'TP021'
export const TRANSPORTISTA = 'TP022'
export const SUSTRACCIONVENTAS = 'TP023'
export const GRUPOCAJAMOVIMIENTO = 'TP024'
export const OFICINA = 'TP025'
export const GRUPOCONTABLEVARIACION = 'TP026'
export const GRUPOCONTABLEGASTO = 'TP027'

export const __dictionary = {
  [MONEDA]: { id: MONEDA, nombre: 'MONEDAS' },
  [LISTAPRECIO]: { id: LISTAPRECIO, nombre: 'LISTAS PRECIO' },
  [GRUPOCONTABLECOMPRA]: { id: GRUPOCONTABLECOMPRA, nombre: 'GRUPOS CONTABLES COMPRA' },
  [GRUPOCONTABLEVENTA]: { id: GRUPOCONTABLEVENTA, nombre: 'GRUPOS CONTABLES VENTA' },
  [GRUPOCONTABLEINVENTARIO]: { id: GRUPOCONTABLEINVENTARIO, nombre: 'GRUPOS CONTABLES INVENTARIO' },
  [GRUPOCONTABLEEXISTENCIA]: { id: GRUPOCONTABLEEXISTENCIA, nombre: 'GRUPOS CONTABLES EXISTENCIA' },
  [CONDUCTOR]: { id: CONDUCTOR, nombre: 'CONDUCTORES' },
  [PLACA]: { id: PLACA, nombre: 'PLACAS' },
  [AREASINTERNAS]: { id: AREASINTERNAS, nombre: 'AREAS INTERNAS' },
  [PLANTILLACOMENTARIOVENTA]: {
    id: PLANTILLACOMENTARIOVENTA,
    nombre: 'PLANTILLA COMENTARIO VENTAS'
  },
  [TECNICO]: { id: TECNICO, nombre: 'TECNICOS' },
  [TALLERSERVICIO]: { id: TALLERSERVICIO, nombre: 'TALLER SERVICIOS' },
  [TALLERSUBSERVICIO1]: { id: TALLERSUBSERVICIO1, nombre: 'TALLER SUB SERVICIOS 1' },
  [TALLERSUBSERVICIO2]: { id: TALLERSUBSERVICIO2, nombre: 'TALLER SUB SERVICIOS 2' },
  [ISLAGRIFO]: { id: ISLAGRIFO, nombre: 'ISLAS GRIFO' },
  [PRECIOXLISTA]: { id: PRECIOXLISTA, nombre: 'PRECIO X LISTA' },
  [MEDIOSPAGO]: { id: MEDIOSPAGO, nombre: 'MEDIOS PAGO' },
  [MEDIOSPAGOVENTAS]: { id: MEDIOSPAGOVENTAS, nombre: 'MEDIOS PAGO VENTAS' },
  [SUBMEDIOSPAGO]: { id: SUBMEDIOSPAGO, nombre: 'SUB MEDIOS PAGO' },
  [TRANSPORTISTA]: { id: TRANSPORTISTA, nombre: 'TRANSPORTISTA' },
  [SUSTRACCIONVENTAS]: { id: SUSTRACCIONVENTAS, nombre: 'RETENCIONES VENTAS' },
  [GRUPOCAJAMOVIMIENTO]: { id: GRUPOCAJAMOVIMIENTO, nombre: 'GRUPO CAJA MOVIMIENTOS' },
  [OFICINA]: { id: OFICINA, nombre: 'OFICINA' },
  [GRUPOCONTABLEVARIACION]: { id: GRUPOCONTABLEVARIACION, nombre: 'GRUPOS CONTABLES VARIACIÓN' },
  [GRUPOCONTABLEGASTO]: { id: GRUPOCONTABLEGASTO, nombre: 'GRUPOS CONTABLES GASTO' }
}

export const __array = [
  __dictionary[MONEDA],
  __dictionary[LISTAPRECIO],
  __dictionary[GRUPOCONTABLECOMPRA],
  __dictionary[GRUPOCONTABLEVENTA],
  __dictionary[GRUPOCONTABLEINVENTARIO],
  __dictionary[GRUPOCONTABLEEXISTENCIA],
  __dictionary[CONDUCTOR],
  __dictionary[PLACA],
  __dictionary[AREASINTERNAS],
  __dictionary[PLANTILLACOMENTARIOVENTA],
  __dictionary[TECNICO],
  __dictionary[TALLERSERVICIO],
  __dictionary[TALLERSUBSERVICIO1],
  __dictionary[TALLERSUBSERVICIO2],
  __dictionary[ISLAGRIFO],
  __dictionary[PRECIOXLISTA],
  __dictionary[MEDIOSPAGO],
  __dictionary[MEDIOSPAGOVENTAS],
  __dictionary[SUBMEDIOSPAGO],
  __dictionary[TRANSPORTISTA],
  __dictionary[SUSTRACCIONVENTAS],
  __dictionary[GRUPOCAJAMOVIMIENTO],
  __dictionary[OFICINA],
  __dictionary[GRUPOCONTABLEVARIACION],
  __dictionary[GRUPOCONTABLEGASTO]
]
